// generated by the plop

import { ReceiptContainerModel } from 'shared';
import { PaginatorModel, PROGRESS_STATUSES } from 'symbols';

export interface TrafficListStateModel {
  trafficList: PaginatorModel<ReceiptContainerModel>;
  loadReceiptListStatus: PROGRESS_STATUSES;
  scrollPosition: number;
  lastOpenedDocId: string;
}

export const TRAFFIC_LIST_STATE_DEFAULT: TrafficListStateModel = {
  trafficList: {
    data: [],
    links: null,
    meta: null
  },
  loadReceiptListStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  scrollPosition: 0,
  lastOpenedDocId: null
};
